import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { FaExternalLinkAlt, FaBookOpen } from "react-icons/fa";

const AdminTableData = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/admin/purchased/courses");
      setTableData(response?.data?.data?.data || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching instructor statistics:", error);
      setError("Failed to load data. Please try again later.");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "40px" }}>
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "20px", background: "#fef2f2", color: "#991b1b", borderRadius: "12px", fontSize: "14px", fontWeight: "600", border: "1px solid #fee2e2" }}>
        {error}
      </div>
    );
  }

  return (
    <div style={{ fontFamily: "'Outfit', sans-serif" }}>
      <div 
        style={{
          background: "white",
          borderRadius: "24px",
          padding: "24px",
          border: "1px solid rgba(226, 232, 240, 0.8)",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.02)",
        }}
      > 
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
          <div style={{ background: "#eff6ff", color: "#3b82f6", padding: "8px", borderRadius: "8px", display: "flex" }}>
            <FaBookOpen />
          </div>
          <p style={{ margin: 0, fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>
            Student Purchased Course List
          </p>
        </div>
        
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "500px" }}>
            <thead>
              <tr style={{ borderBottom: "2px solid #f1f5f9" }}>
                <th style={{ textAlign: "left", padding: "12px 16px", fontSize: "11px", fontWeight: "800", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Course Name</th>
                <th style={{ textAlign: "left", padding: "12px 16px", fontSize: "11px", fontWeight: "800", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Student Name</th>
                <th style={{ textAlign: "left", padding: "12px 16px", fontSize: "11px", fontWeight: "800", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Purchased Date</th>
                <th style={{ textAlign: "center", padding: "12px 16px", fontSize: "11px", fontWeight: "800", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {tableData && tableData.length > 0 ? (
                tableData.map((item, index) => (
                  <tr 
                    key={index} 
                    style={{ 
                      borderBottom: "1px solid #f1f5f9",
                      transition: "background-color 0.2s"
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#f8fafc"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
                  >
                    <td style={{ padding: "14px 16px", fontSize: "13px", fontWeight: "700", color: "#1e293b" }}>
                      {item.CourseName}
                    </td>
                    <td style={{ padding: "14px 16px", fontSize: "13px", fontWeight: "600", color: "#475569" }}>
                      {item.studentName}
                    </td>
                    <td style={{ padding: "14px 16px", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>
                      {item.orderCreatedOn ? format(new Date(item.orderCreatedOn), "MMM dd, yyyy") : "N/A"}
                    </td>
                    <td style={{ padding: "14px 16px", textAlign: "center" }}>
                      <button
                        onClick={() => navigate('/dashboard/course/list')}
                        style={{
                          border: "none",
                          background: "#f1f5f9",
                          color: "#475569",
                          width: "32px",
                          height: "32px",
                          borderRadius: "8px",
                          cursor: "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transition: "all 0.2s ease"
                        }}
                        onMouseEnter={(e) => { 
                          e.currentTarget.style.background = "#e2e8f0";
                          e.currentTarget.style.color = "#0f172a";
                        }}
                        onMouseLeave={(e) => { 
                          e.currentTarget.style.background = "#f1f5f9";
                          e.currentTarget.style.color = "#475569";
                        }}
                      >
                        <FaExternalLinkAlt style={{ fontSize: "12px" }} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center", padding: "30px", color: "#94a3b8", fontSize: "13px", fontWeight: "600" }}>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminTableData;